// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import pmorepEntity from './entities/pmorep.json';
import pmorepMenu from '../pages/pmorep/menu.json';
import pmorepFullForm from '../pages/pmorep/forms/full.json';
import pmorepContextForm from '../pages/pmorep/forms/context.json';
import pmorepMiniForm from '../pages/pmorep/forms/mini.json';
import pmorepLookupForm from '../pages/pmorep/forms/lookup.json';
import pmorepTableView from '../pages/pmorep/views/table.json';
import pmorepStagesView from '../pages/pmorep/views/stages.json';
import pmorepCardsView from '../pages/pmorep/views/cards.json';
import pmorepInlineView from '../pages/pmorep/views/inline.json';
import pmorepBacklogView from '../pages/pmorep/views/backlog.json';
import pmorepSplitView from '../pages/pmorep/views/split.json';
import pmorepCalendarView from '../pages/pmorep/views/calendar.json';
import pmorepDashboardView from '../pages/pmorep/views/dashboard.json';

/** Тип запису «Звіт про стан» зі сторінками пакета: меню, форми та подання з pages/pmorep/. */
export const pmorepDefinition: IRecordTypeDefinition = {
  ...pmorepEntity,
  views: assembleViewSet({
      table: pmorepTableView,
      stages: pmorepStagesView,
      cards: pmorepCardsView,
      inline: pmorepInlineView,
      backlog: pmorepBacklogView,
      split: pmorepSplitView,
      calendar: pmorepCalendarView,
      dashboard: pmorepDashboardView,
  }),
  form: pmorepFullForm,
  forms: { full: pmorepFullForm, context: pmorepContextForm, mini: pmorepMiniForm, lookup: pmorepLookupForm },
  menu: pmorepMenu,
} as IRecordTypeDefinition;
